import {
  Image,
  InputNumber,
  InputPinCode,
  InputText,
  Loading,
  PopupWraper,
} from 'components';
import { Button, InputWraper, useForm } from 'modules';
import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { MainRouteKeys } from 'routes/enums';
import {
  useCheckPhoneNumberTransferQuery,
  useCheckPinCodeMutation,
  useWalletTransferMutation,
  useGetBalanceQuery,
} from 'services';
import { UserSearchEntity } from 'services/openapi';
import { getUserInfo } from 'utils/helpers';

import { formSchema, formSchemaPinCode } from './config';

const BalanceTransferFeature = (): JSX.Element => {
  const [phoneNumber, setPhoneNumber] = useState<string>('');

  const [phoneNumberDebounce, setPhoneNumberDebounce] = useState<string>('');

  const [isShowPopup, setIsShowPopup] = useState<boolean>(false);

  const navigator = useNavigate();

  const {
    data: dataCheckPhoneNo,
    isFetching,
    refetch,
  } = useCheckPhoneNumberTransferQuery({ phoneNumber });

  const {
    mutateAsync: mutateAsyncCheckPinCode,
    isLoading: isLoadingCheckPinCode,
  } = useCheckPinCodeMutation();

  const { mutateAsync: mutateAsyncTransfer, isLoading } =
    useWalletTransferMutation();

  const { refetch: refetchBalance } = useGetBalanceQuery();

  const { handleSubmit, getInputProps, getValue } = useForm({
    structure: formSchema,
    onSubmit: () => setIsShowPopup(true),
  });

  const { handleSubmit: handleSubmitModal, getInputProps: getInputPropsModal } =
    useForm({
      structure: formSchemaPinCode,
      onSubmit: handleCheckPinCode,
    });

  useEffect(() => {
    const timeout = setTimeout(() => {
      setPhoneNumberDebounce(phoneNumber);
    }, 500);

    return () => clearTimeout(timeout);
  }, [phoneNumber]);

  useEffect(() => {
    if (phoneNumberDebounce) {
      refetch();
    }
  }, [phoneNumberDebounce]);

  async function handleCheckPinCode(values: any) {
    const { pinCode } = values;

    const { id: fundId } = getUserInfo();

    const amount = getValue('amount');

    try {
      const dataCheckPinCode = await mutateAsyncCheckPinCode({ pinCode });

      if (!dataCheckPinCode?.isValid) {
        dataCheckPinCode?.message?.map((item: string) => toast.error(item));
      }
      if (dataCheckPinCode && dataCheckPinCode?.isValid) {
        const dataTransfer = await mutateAsyncTransfer({
          toUserId: dataCheckPhoneNo?.data?.[0]?.id || '',
          amount,
          reason: '',
          pinCode,
          fundId,
        });

        if (dataTransfer && dataTransfer?.statusCode === 200) {
          refetchBalance();
          setIsShowPopup(false);
          toast.success('Chuyển điểm thành công');
          navigator(MainRouteKeys.Balance);
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  const renderDataUser = () => {
    if (!dataCheckPhoneNo) {
      return <div> </div>;
    }

    if (!dataCheckPhoneNo?.data?.length) {
      return <div>Không tìm thấy tài khoản</div>;
    }

    return dataCheckPhoneNo?.data?.map((item: UserSearchEntity) => (
      <div key={item.id} className='UserHead'>
        <div className='profile ctas'>
          <Image
            src={
              item?.avatar
                ? `${process.env.REACT_APP_UPLOAD_AVT}${item?.avatar}`
                : '/assets/images/no-image.jpg'
            }
            type='avatar'
          />
          <div className='info'>
            <div className='name'>{item?.fullName}</div>
            <div className='email'>{item?.phoneNumber}</div>
          </div>
        </div>
      </div>
    ));
  };

  return (
    <>
      <div className='row'>
        <div className='col-md-8 balance-management'>
          <div className='balance-management__title'>Chuyển điểm</div>

          <form onSubmit={handleSubmit}>
            <Loading
              isLoading={isFetching}
              className='row justify-content-center balance-management__form'
            >
              <div className='col-md-6'>
                <InputWraper
                  label='Người nhận'
                  inputProps={getInputProps('phoneNumber')}
                  onChangeCallback={setPhoneNumber}
                  component={InputText}
                />
              </div>

              <div className='col-md-6'>
                <InputWraper
                  label='Số điểm'
                  component={InputNumber}
                  inputProps={getInputProps('amount')}
                />
              </div>

              <div className='col-12 balance-management__form--btn'>
                {renderDataUser()}
                <Button
                  type='submit'
                  isLoading={isLoading}
                  disabled={
                    !dataCheckPhoneNo?.data?.length || !getValue('amount')
                  }
                  buttonType='success'
                  label='Chuyển điểm'
                />
              </div>
            </Loading>
          </form>
        </div>
      </div>

      {isShowPopup && (
        <PopupWraper
          center
          title='Nhập mật khẩu'
          onClose={() => setIsShowPopup(false)}
        >
          <form onSubmit={handleSubmitModal} className='charge-bill-container'>
            <Loading isLoading={isLoading || isLoadingCheckPinCode}>
              <div className='charge-bill__title'>
                <InputWraper
                  label='Mật khẩu'
                  inputProps={getInputPropsModal('pinCode')}
                  component={InputPinCode}
                />
              </div>
              <div className='charge-bill__button-container'>
                <Button
                  className='button__confirm'
                  label='Xác nhận'
                  buttonType='success'
                  type='submit'
                />
                <Button
                  className='button__cancel'
                  onClick={() => setIsShowPopup(false)}
                  label='Trở về'
                  buttonType='primary-outline'
                />
              </div>
            </Loading>
          </form>
        </PopupWraper>
      )}
    </>
  );
};

export default BalanceTransferFeature;
